import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { TableHeaderMixin } from '../../mixins/components/TableHeaderMixin';
import { TableHeaderCellProvider } from '../../js/TableHeaderCellContext';
export var StyledTableHeader = /*#__PURE__*/styled.thead.withConfig({
  displayName: "StyledTableHeader",
  componentId: "c11n-8-64-0__sc-1ba0xxh-0"
})(["", ""], TableHeaderMixin);
/**
 * TableHeader
 *
 * @since 8.0.0
 */

var TableHeader = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(TableHeaderCellProvider, {
    value: {
      parent: 'header'
    }
  }, /*#__PURE__*/React.createElement(StyledTableHeader, _extends({
    ref: ref
  }, props)));
});
TableHeader.displayName = 'Table.Header';
TableHeader.propTypes = {
  /**
   * Background style of the table header.
   */
  appearance: PropTypes.oneOf(['light', 'dark'])
};
TableHeader.defaultProps = {
  appearance: 'light'
};
/** @component */

export default TableHeader;